<template>
  <v-app>
    <v-toolbar color="primary" class="toolbar">
      <v-container fluid pa-0 class="my__toolbar">
        <v-row class="align-center justify-center">
          <v-col class="col-3 col-md-5 d-md-none">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  text
                  class="navbar-buttons primary--text justify-start pa-0"
                  color="white"
                  v-on="on"
                >
                  <v-icon size="26">menu</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn
                      text
                      href="https://ondivannet.wordpress.com/"
                      target="_blank"
                      class="navbar-buttons primary--text mr-2"
                    >
                      <v-icon class="mr-2">subject</v-icon>Blogue
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn to="/sobre" text class="navbar-buttons primary--text">
                      <img
                        :src="require('../../assets/icon_ondivan.png')"
                        class="mr-3"
                        style="width: 20px;"
                      />
                      Sobre Nós
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <a href="/paciente" class="navbar-buttons white  primary--text button-anchor">
                      <v-icon class="primary--text mr-2">record_voice_over</v-icon>Sou Paciente
                    </a>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <a href="/psicologo" class="navbar-buttons white  primary--text button-anchor">
                      <v-icon class="primary--text mr-2">hearing</v-icon>Sou Psicólogo
                    </a>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col class="col-5 col-md-5 disappear-mobile">
            <v-btn
              href="https://ondivannet.wordpress.com/"
              target="_blank"
              color="white"
              class="navbar-buttons primary--text mr-2"
            >
              <v-icon>subject</v-icon>Blogue
            </v-btn>
            <v-btn to="/sobre" color="white" class="navbar-buttons primary--text">
              <img
                :src="require('../../assets/icon_ondivan.png')"
                class="mr-2"
                style="width: 20px;"
              />
              Sobre Nós
            </v-btn>
          </v-col>
          <v-col class="col-7 col-md-2 offset-1 offset-md-0">
            <v-row class="align-center justify-md-center">
              <img :src="require('../../assets/ondivan_marca_white.svg')" width="70%;" />
            </v-row>
          </v-col>
          <v-col class="col-5 col-md-5 disappear-mobile">
            <v-row class="justify-end">
              <a href="/paciente" class="navbar-buttons white  primary--text button-anchor">
                <v-icon class="primary--text mr-2">record_voice_over</v-icon>Sou Paciente
              </a>
              <a href="/psicologo" class="navbar-buttons white  primary--text button-anchor">
                <v-icon class="primary--text mr-2">hearing</v-icon>Sou Psicólogo
              </a>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-toolbar>

    <section class="hero-section cover">
      <div class="px-2">
        <h1 class="primary--text begin-therapy text-center mt-3">Comece a sua terapia online</h1>
        <h2
          class="primary--text begin-therapy-subtitle text-center mt-2"
        >Acesso a Psicólogos de excelência a qualquer hora e em qualquer lugar</h2>
      </div>
      <div class="text-center mt-4">
        <v-col class="col-12 col-md-4 offset-md-4 px-3">
          <iframe
            class="mb-3 video-youtube"
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/WBBGRuWVcDE"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </v-col>

        <div class="trasparent-background pt-1 px-2">
          <h1 class="primary--text schedule-begin-therapy text-xs-center mt-3">
            Agendar um atendimento é muito fácil!
          </h1>
          <v-container>
            <v-row class="justify-center">
              <v-col class="col-12 col-xs-4 col-md-4 justify-center">
                <div class="white white-box d-flex align-center row justify-center">
                  <v-icon class="primary--text" size="45">search</v-icon>
                </div>
                <p class="schedule-text black--text mt-3">
                  <strong class="font-size-title-grid">Procure um psicólogo</strong>
                  <br />
                  <span class="font-size-body-grid"> Profissionais de todas as áreas</span>
                </p>
              </v-col>
              <v-col class="col-12 col-xs-4 col-md-4 justify-center">
                <div class="white white-box d-flex align-center row justify-center">
                  <v-icon class="primary--text" size="45">calendar_today</v-icon>
                </div>
                <p class="schedule-text black--text mt-3">
                  <strong class="font-size-title-grid">Agende sua consulta</strong>
                  <br />
                  <span class="font-size-body-grid">Escolha o seu melhor dia e horário</span>
                </p>
              </v-col>
              <v-col class="col-12 col-xs-4 col-md-4 justify-center">
                <div class="white white-box d-flex align-center row justify-center">
                  <v-icon class="primary--text" size="45">credit_card</v-icon>
                </div>
                <p class="schedule-text black--text mt-3">
                  <strong class="font-size-title-grid">Pague online</strong>
                  <br />
                  <span class="font-size-body-grid">Link do pagamento via email</span>
                </p>
              </v-col>
            </v-row>

            <!-- <div class="text-xs-center">
              <a href="#news"
                color="secondary"
                class="primary--white newstitle btn-hero-register"
              >Disponível em breve!</a>
            </div> -->
          </v-container>
        </div>
      </div>
    </section>

    <section class="section-2">
      <v-container fluid pa-0>
        <v-row class="ma-0">
          <v-col class="col-12 col-md-6 d-flex align-end justify-center section-2-box s2-box1 cover pa-0">
            <div class="trasparent-background px-3">
              <v-row class="py-2 d-flex align-center justify-center">
                <v-col class="col-12 col-md-9 align-center text-center">
                  <div class="white pa-1 d-flex align-center justify-center mb-6">
                    <strong>
                      <span class="headline font-weight-bold black--text mb-0">O divã feito para si.</span>
                    </strong>
                  </div>
                  <v-btn
                    to="/paciente/cadastro"
                    color="secondary"
                    large
                    class="primary--white"
                  >Registe-se</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col calss="col-12 col-md-6">
                  <p class="text-xs-left black--text">
                    Encontre o Psicólogo ideal com sigilo, conforto e a segurança do pagamento online.
                  </p>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col class="col-12 col-md-6 d-flex align-end justify-center section-2-box s2-box2 cover pa-0">
            <div class="trasparent-background px-3">
              <v-row class="py-2 d-flex align-center justify-center">
                <v-col class="col-12 col-md-9 align-center text-center">
                  <div class="white pa-1 d-flex align-center justify-center mb-6">
                    <strong>
                      <span class="headline font-weight-bold black--text mb-0">O parceiro do Psicólogo.</span>
                    </strong>
                  </div>
                  <v-btn
                    to="/psicologo/cadastro"
                    color="secondary"
                    large
                    class="primary--white"
                  >Registe-se</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col calss="col-12 col-md-6">
                  <p class="text-xs-left black--text">
                    Trabalhe online gerindo a sua própria agenda e tenha acesso a uma nova gama de clientes e contactos.
                  </p>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section>
      <v-container fluid class="pa-0">
        <v-row class="ma-0">
          <v-col class="col-12 col-md-6">
            <v-row class="align-center justify-center">
              <v-col class="col-12 col-md-2 d-flex align-center justify-center py-4">
                <div class="px-3">
                  <img :src="require('../../assets/icon_ondivan.png')" class="contain w-100" />
                </div>
              </v-col>
              <v-col class="col-12 col-md-6 align-center justify-center text-center">
                <h1 class="black--text therapy-online-title">Psicoterapia Online</h1>
                <h2 class="black--text therapy-online-subtitle">Psicólogo online, Porquê?</h2>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col class="col-10 col-md-10">
                <p
                  class="mb-0 black--text why-text mt-3"
                >Na corrida do dia-a-dia, vários fatores podem mobilizar-nos emocionalmente e levar-nos a procurar respostas. A Psicologia pode ser um meio para as encontrar dentro de si.</p>
                <p
                  class="mb-0 black--text why-text mt-3"
                >Um Psicólogo online oferece-lhe a comodidade de ser atendido onde estiver, exigindo apenas um PC/telemóvel com uma boa ligação à internet e privacidade. Pode estar no conforto da sua casa ou até em viagem, num quarto de hotel, economizando tempo e dinheiro nas deslocações, mantendo a qualidade e os resultados da terapia presencial.</p>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col class="col-10 col-md-10" style= "padding-top: 10px">
                <img :src="require('../../assets/team.png')" class="w-100 image-team fit-cover" />
              </v-col>
            </v-row>
          </v-col>
          <v-col class="col-12 col-md-6">
            <v-row class="justify-center">
              <v-col class="col-10 col-md-10">
                <p class="black--text why-text mt-3">
                  <strong>E funciona?</strong>
                  <br/>
                </p>
                <p
                  class="mb-0 black--text why-text mt-3"
                >Até há pouco tempo, era comum as pessoas pensarem que apenas o portador de graves doenças mentais é que precisava de ir ao Psicólogo, mas hoje quebraram-se os tabus e a Psicologia assumiu o seu lugar mais amplo de ser também promotora de bem-estar.</p>
                <p class="mb-0 black--text why-text mt-3">
                  Se:
                  <br />Se sente triste, desmotivado, ansioso, angustiado…
                  <br />Não consegue tomar decisões…
                  <br />Não se sente ajustado à família ou amigos…
                  <br />Encontra dificuldades para dormir…
                  <br />Possui comportamentos compulsivos…
                  <br />Apresenta uma timidez que o impede de ser bem-sucedido socialmente…
                  <br />Foi viver para outro país e se sente abalado…
                  <br/>
                  <br />Um Psicólogo possui as ferramentas mais adequadas para o auxiliar.
                  <br/>
                  <br />Conheça hoje mesmo os nossos profissionais. O Ondivan vai acolhê-lo e ajudá-lo a enfrentar e a superar as suas questões.
                </p>

                <div class="text-xs-center">
                  <!-- <v-btn
                    color="secondary"
                    large
                    class="primary--white minor-text btn-professionals mt-5 mb-4"
                    to="/paciente/login/"
                  >
                    <v-icon class="white--text mr-3 subtitle-hero">hearing</v-icon>Clique aqui e conheça
                    <br />os nossos profissionais
                  </v-btn> -->
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="lightGray row-carousel-item">
      <v-row class="justify-center align-center ma-0">
        <v-icon class="primary--text subtitle-hero mr-3">favorite</v-icon>
        <h2 class="black--text opinion-title news-text text-center my-3">
        Testemunhos dos nossos clientes
        </h2>
      </v-row>
      <v-carousel light height="auto" :interval="10000" class="pb-4">
        <v-carousel-item>
          <v-row class="align-start justify-center ma-0">
            <v-col class="col-9 col-md-8">
              <div class="text-center">
                <img :src="require('../../assets/caso5.jpeg')" class="image-client fit-cover" />
              </div>
              <div class="text-center">
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
              </div>
              <h2 class="black--text news-text text-center">C.L. / Portugal</h2>
              <p class="black--text text-center mb-5">
                Gostaríamos de dar o nosso depoimento de pais, sobre o trabalho desta maravilhosa profissional e pessoa, que consideramos ser fundamental na nossa vida familiar e pessoal até hoje!
                <br />
                <br />Viemos sem "manual de instruções" e alguns conceitos que acreditamos e foram passados pelos nossos pais, não são os mais adequados para os dias de hoje. Muitas vezes escolhemos caminhos para os nossos filhos que não são os caminhos que eles querem para eles e com isso os afastamos da sua essência, de nós e abre-se espaço para os conflitos internos e externos!
                <br />
                <br />A Dra. Inês Mata tem sido uma verdadeira amiga e uma profissional com um exímio desempenho. Conhecê-la e confiar-lhe o nosso bem mais precioso, a nossa filha, foi o melhor que podíamos ter feito. Ela tem sido importantíssima na vida da nossa filha, e na nossa! Soubemos através de um familiar, que a psicóloga Inês Mata realizava atendimentos online: foi uma bênção, um renascimento! Hoje sei que nada é em vão e que esta terapeuta, que se tornou uma verdadeira amiga, foi posta na nossa vida para nos ajudar a reestruturar a vida familiar. Ela é um ser humano único e maravilhoso! Sabe usar as “ferramentas" necessárias para as situações difíceis e conflituosas que precisamos ultrapassar. Todo este trabalho tem sido um crescimento pessoal e uma compreensão dos sentimentos e emoções, da nossa filha! Nós pais, apercebemo-nos destas mudanças positivas e agradecemos ter alguém em quem confiar, e partilhar como a Dra. Inês Mata!
              </p>
            </v-col>
          </v-row>
        </v-carousel-item>
        <v-carousel-item>
          <v-row class="align-start justify-center ma-0">
            <v-col class="col-9 col-md-8">
              <div class="text-center">
                <img :src="require('../../assets/caso6.jpg')" class="image-client fit-cover" />
              </div>
              <div class="text-center">
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
              </div>
              <h2 class="black--text news-text text-center">L.B. / Brasil</h2>
              <p class="black--text text-center mb-5">
                Sempre tive receio em contratar um serviço de psicologia online, acreditava que desumanizava uma prestação de serviço muito delicada à saúde mental.
                <br />
                <br />
                Porém o Ondivan me surpreendeu, ao ter um contato direto com o paciente e uma ótima seleção de psicólogos.
                Agora me sinto confiante para ter apoio psicológico, sem barreiras físicas e/ou temporais. Sem contar com a facilidade e segurança do pagamento online, feito em apenas um clique.
              </p>
            </v-col>
          </v-row>
        </v-carousel-item>
        <v-carousel-item>
          <v-row class="align-start justify-center ma-0">
            <v-col class="col-9 col-md-8">
              <div class="text-center">
                <img :src="require('../../assets/caso1.png')" class="image-client fit-cover" />
              </div>
              <div class="text-center">
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
              </div>
              <h2 class="black--text news-text text-center">J.C. / Brasil</h2>
              <p class="black--text text-center m-0">
                Fazer a terapia online foi a melhor coisa que me aconteceu! Estava num estado melancólico tão profundo que sair de casa era um sacrifício grande, terminava sabotando as terapias que tentava iniciar. Desta vez está sendo diferente, faço as sessões em casa onde me sinto bastante a vontade, no início mesmo sem vontade de levantar da cama era de lá mesmo que ouvia minha psicologa me levantar o astral e mostrar que eu era muito mais, que meu corpo estava apenas respondendo a um estado de letargia que a minha cabeça tentava persuadir.
                <br />
                <br />Aos poucos fui me fortalecendo, me encontrando, e buscando dentro de mim uma força que nem imaginava existir. Hoje, faço a terapia onde eu quiser, num quarto de hotel, numa sala de estudos dentro de uma livraria de shopping.
                <br />
                <br />Estou aprendendo a andar com meus próprios pés, entendendo que a única pessoa que vai mudar a minha história sou eu! E eu posso!
                <br />
                <br />A Dra. Inês Mata tem transformado a minha vida! Eterna gratidão por essa Psicológa!
              </p>
            </v-col>
          </v-row>
        </v-carousel-item>
        <v-carousel-item>
          <v-row class="align-start justify-center ma-0">
            <v-col class="col-9 col-md-8">
              <div class="text-center">
                <img :src="require('../../assets/caso2.png')" class="image-client fit-cover" />
              </div>
              <div class="text-center">
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
              </div>
              <h2 class="black--text news-text text-center">L.M. / Dinamarca</h2>
              <p class="black--text text-center mb-5">
                "Não podemos nos afastar do que somos enquanto não aceitarmos profundamente o que somos" - Carl Rogers.
                <br />
                <br />Com a Dra. Inês Mata o caminho do autoconhecimento se transformou muito mais claro, e mais fácil de ser seguido.
                <br />
                <br />Hoje em dia moro fora do Brasil, e após a mudança de país, a terapia online se tornou uma ferramenta importantíssima, e muito útil. Além de toda praticidade que é conseguida através do atendimento online, a Dra. Inês faz com que a pessoa se sinta bem acolhida, atendida, prestando sempre atenção e sabendo a hora certa de intervir.
                <br />
                <br />Agradeço muito por ser sua paciente, e com certeza todo o caminho de sucesso e de auto descobertas que fiz não seria o mesmo - e posso dizer que não seria nada melhor - sem a ajuda dela.
                <br />Muito obrigada por tudo.
              </p>
            </v-col>
          </v-row>
        </v-carousel-item>
        <v-carousel-item>
          <v-row class="align-start justify-center ma-0">
            <v-col class="col-9 col-md-8">
              <div class="text-center">
                <img :src="require('../../assets/caso3.jpeg')" class="image-client fit-cover" />
              </div>
              <div class="text-center">
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
              </div>
              <h2 class="black--text news-text text-center">C.S. / Brasil</h2>
              <p class="black--text text-center mb-5">
                O que falar sobre o trabalho desenvolvido por essa profissional tão comprometida e competente?
                <br />Há três anos comecei minha terapia com Dra Inês onde as consultas eram presenciais. Ela me ajudou bastante no meu autoconhecimento e superação de inúmeras questões pessoais.
                <br />
                <br />Ha cerca de dois anos iniciamos as sessões online. No início, estava bastante resistente a ideia pois achava que sentiria falta do contato físico.
                <br />
                <br />Contudo, a experiência foi surpreendente. A consulta manteve-se com a mesma qualidade só que mais acessível diante das facilidades tecnológicas e estou ainda mais satisfeita com o serviço e apoio dessa excelente profissional que tanto admiro e respeito!
              </p>
            </v-col>
          </v-row>
        </v-carousel-item>
        <v-carousel-item>
          <v-row class="align-start justify-center ma-0">
            <v-col class="col-9 col-md-8">
              <div class="text-center">
                <img :src="require('../../assets/caso4.jpeg')" class="image-client fit-cover" />
              </div>
              <div class="text-center">
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
                <v-icon class="warning--text icon-star">star</v-icon>
              </div>
              <h2 class="black--text news-text text-center">J.M. / Suécia</h2>
              <p class="black--text text-center mb-5">
                Se descobrir e entender a si mesmo, encontrar as ferramentas para enfrentar os desafios da vida; os desconhecidos, aqueles que assustam e aqueles que vêm cheios de expectativas. Não se perder no caminho e achar o equilíbrio entre peso e leveza.
                <br />
                <br />Com a ajuda da Dra. Inês Mata, percorri um caminho que me exigiu voltar a aprender sobre o meu passado, a olhar para mim no dia de hoje para me redescobrir e trabalhar com esse aprendizado para construir meu futuro. Os atendimentos on-line da psicóloga Inês Mata; seu profissionalismo, disposição e flexibilidade tornaram possível esse crescimento pessoal.
              </p>
            </v-col>
          </v-row>
        </v-carousel-item>

      </v-carousel>
    </section>

    <section class="section-midia px-2">
      <v-row class="align-center justify-center ma-0">
        <v-col class="col-12 col-md-6">
          <h1 class="black--text text-center therapy-online-title">
            <v-icon class="secondary--text" size="60">track_changes</v-icon>
            Na Comunicação Social
          </h1>
        </v-col>
      </v-row>

      <p class="black--text text-center media-subtitle">
        <u>“Ondivan lança serviço de psicologia online em Portugal”</u>
      </p>

      <!-- <v-container grid-list-lg>
        <v-row row align-center justify-center wrap>
          <v-col xs6 md2>
            <div class="primary white-box-midia w-100"></div>
          </v-col>
          <v-col xs6 md2>
            <div class="primary white-box-midia w-100"></div>
          </v-col>
          <v-col xs6 md2>
            <div class="primary white-box-midia w-100"></div>
          </v-col>
          <v-col xs6 md2>
            <div class="primary white-box-midia w-100"></div>
          </v-col>
          <v-col xs6 md2>
            <div class="primary white-box-midia w-100"></div>
          </v-col>
          <v-col xs6 md2>
            <div class="primary white-box-midia w-100"></div>
          </v-col>
        </v-row>
      </v-container> -->
    </section>

    <section id="news">
      <v-row class="align-center justify-center ma-0">
        <v-col class="col-3 offset-1 col-md-1 offset-md-3 d-flex align-center justify-end">
          <v-icon class="primary--text" size="60">email</v-icon>
        </v-col>
        <v-col class="col-6 col-md-5 align-center justify-md-center">
          <h1 class="primary--text therapy-online-title">Newsletter</h1>
        </v-col>
      </v-row>
      <p class="mb-0 text-center primary--text news-text px-2">
        Inscreva-se e receba novidades do Ondivan.
      </p>
      <v-row class="row align-center justify-center ma-0">
        <v-col class="col-10 col-md-3">
          <v-radio-group row v-model="radioValue" :mandatory="true">
            <v-radio value="LnGm" label="Paciente" color="primary"></v-radio>
            <v-radio value="LnGc" label="Psicólogo" color="primary"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row class="column px-3 ma-0">
        <v-col class="col-12 col-md-12 justify-center">
          <v-row class="justify-center align-center">
            <v-col class="col-10 col-md-3">
              <v-text-field hide-details solo flat v-model="email" label="Seu email" background-color="#F7F7F7"></v-text-field>
            </v-col>
            <v-col class="col-10 col-md-2 text-center text-md-start pl-md-0">
              <v-btn color="secondary" class="primary--white" @click="signUp">Enviar</v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="col-10 col-md-4 align-self-center">
          <v-alert
            v-model="isAlert"
            :value="true"
            :type="isType"
            dismissible
          >
            {{ msg }}
          </v-alert>
        </v-col>
      </v-row>
    </section>

    <v-footer height="auto" color="primary">
      <v-row class="align-center justify-center ma-0">
        <v-col class="py-3 text-center white--text col-12 col-md-2" style="font-size: 12px">
          <img :src="require('../../assets/ondivan_marca_white.svg')" width="180px;" />
        </v-col>
        <v-col class="py-3 text-center white--text col-12 col-md-2" style="font-size: 14px">
          <strong>RESPONSÁVEL TÉCNICO:</strong>
          <br />Inês Mata OPP: CP 23204
        </v-col>
        <v-col class="py-3 d-flex text-center align-center justify-space-around col-12 col-md-2" style="font-size: 14px">
          <div>
            <a
              href="https://www.livroreclamacoes.pt/"
              target="_blank"
              class="white--text"
            >
              Livro de Reclamações
            </a>
          </div>
          <div>
            <a href="/privacidade" class="white--text">Política de privacidade</a>
          </div>
        </v-col>
        <v-col class="py-3 text-center col-12 col-md-2" style="font-size: 14px">
          <a target="blank" href="https://fb.me/ondivan.net">
            <img :src="require('../../assets/facebook_icon.png')" width="40px;" />
          </a>
          <a target="blank" href="https://www.instagram.com/on.divan/">
            <img :src="require('../../assets/instagram_icon.png')" width="40px;" class="ml-4" />
          </a>
        </v-col>
        <v-col class="pa-3 row text-center col-12 col-md-2 align-center d-flex" style="font-size: 12px">
          <div class="d-flex row align-center justify-center">
            <div>
              <p class="mb-1 mr-1 white--text" style="font-size: 1.2rem;">
                <strong>Email:</strong>geral@ondivan.net
              </p>
            </div>
            <div>
            <!-- <a target="blank" href="https://www.easypay.pt/">
              <img :src="require('../../assets/easypay.jpg')" style="width: 100px;" />
              </a> -->
            </div>
          </div>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import Axios from 'axios';

export default {
  data() {
    return {
      email: '',
      radioValue: 'LnGm',
      msg: '',
      isAlert: false,
      isType: 'error',
    };
  },
  methods: {
    async signUp() {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      };

      try {
        const result = await Axios.post('https://api.criaenvio.com/v1/contatos?chave=alpaaDYua2c2WTMud2I0WjUuLWFwSFVmLmgxejJM', { email: this.email }, config);
        if (result.error) {
          console.log('Deu erro');
        } else {
          const { id } = result.data.data;
          const res = await Axios.post(`https://api.criaenvio.com/v1/contatos/${id}/inscrever?chave=alpaaDYua2c2WTMud2I0WjUuLWFwSFVmLmgxejJM`, { idGrupos: this.radioValue }, config);
          if (res.error) {
            console.log('Deu erro');
          } else {
            this.msg = 'Cadastro realizado com sucesso!';
            this.isType = 'success';
            this.isAlert = true;
            this.email = '';
          }
        }
      } catch (error) {
        this.msg = error.response.data.error.message;
        this.isAlert = true;
      }
    },
  },
};
</script>


<style lang="css" scoped>
* >>> .v-carousel {
  box-shadow: none !important;
}

* >>> .v-carousel__controls {
  background: rgba(0, 0, 0, 0) !important;
}

* >>> .v-carousel__controls__item .v-btn__content .v-icon {
  color: #93291E;
}
/* * >>> .v-carousel__controls__item {
  color: var(--v-primary-base) !important;
} */

.toolbar {
  height: auto;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

.white-box {
  margin: 0 auto;
  width: 100px;
  height: 100px;
  border-radius: 8px;
}

.hero-section {
  background: url(../../assets/hero-background.png) no-repeat;
}

.btn-hero-register {
  height: 65px !important;
}

/* .icon-schedule {
  font-size: 6rem !important;
} */

.hero-text,
.register-title,
.schedule-text,
.media-subtitle {
  font-size: 1.7rem;
}

.news-text,
.opinion-title {
  font-size: 2rem;
}

.subtitle-hero,
.begin-therapy,
.schedule-begin-therapy,
.newstitle,
.therapy-online-title,
.icon-star {
  font-size: 3rem;
}

.trasparent-background {
  background-color: rgba(255, 255, 255, 0.8);
}

.v-input--radio-group {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}

.cover {
  background-size: cover !important;
}

.fit-cover {
  object-fit: cover;
}

.s2-box1 {
  background: url(../../assets/girl.png) no-repeat;
}

.s2-box2 {
  background: url(../../assets/office.png) no-repeat;
}

.section-2-box {
  height: 30vh;
}

.section-2-box p {
  font-size: 1.3rem;
}

.minor-text,
.why-text {
  font-size: 1.6rem;
}

.icon-news {
  font-size: 4rem;
}

.contain {
  object-fit: contain;
}

.w-100 {
  width: 100%;
}

.btn-professionals {
  height: 80px !important;
}

.image-team {
  height: 400px;
}

.image-client {
  border-radius: 50%;
  width: 95px;
  height: 95px;
  margin: 0 auto;
}

.carousel-firstblock h2 {
  text-align: left;
  margin-left: 28px;
}

.white-box-midia {
  height: 100px;
}

.section-midia {
  background-image: url(../../assets/bg_namidia.png),
    url(../../assets/bg_namidia.png);
  background-repeat: repeat-x, repeat-x;
  background-position: 0 top, 0 bottom;
  background-color: #e8fcfd;
  padding-top: 60px;
  padding-bottom: 60px;
}

.button-anchor {
    border-radius: 8px;
    text-transform: uppercase;
    font-weight: 500;
    height: 36px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    text-decoration: none;
    margin: 0px 5px;
}

.font-size-title-grid {
  font-size: 24px;
}

.font-size-body-grid {
  font-size: 22px;
}

@media screen and (min-width: 1024px) {
  .opinion-client {
    font-size: 1.3rem;
  }

  .section-2-box {
    height: 50vh;
  }

  * >>> .slick-next:before,
  * >>> .slick-prev:before {
    font-size: 63px;
  }

  * >>> .slick-next {
    right: 55px !important;
  }

  .therapy-online-title {
    line-height: 41px;
  }
}

.v-input__control {
  width: 100% !important;
}

@media screen and (min-width: 760px) {
  .row-carousel-item {
    padding: 0 48px;
  }

  .hero-section {
    background-position: 44% 0;
  }
}
@media screen and (max-width: 420px) {
  .v-menu--inline {
    display: none !important;
  }

  .disappear-mobile {
    display: none;
  }

  .navbar-buttons {
    font-size: 10px;
    justify-content: start;
    margin: 0;
  }

  .btn-professionals,
  .section-2-box p,
  .why-text {
    font-size: 1rem;
  }

  .opinion-title,
  .begin-therapy-subtitle,
  .schedule-begin-therapy,
  .media-subtitle {
    font-size: 1.2rem;
  }

  .register-title {
    font-size: 2rem;
  }

  .section-2-box {
    height: 60vh;
  }

  .my__toolbar img {
    width: 40%;
  }

  .newstitle,
  .begin-therapy {
    font-size: 1.7rem;
  }

  .icon-schedule {
    font-size: 3rem;
  }

  .begin-therapy-subtitle {
    line-height: 19px;
  }

  .therapy-online-title {
    font-size: 2rem;
  }

  .schedule-text {
    font-size: 0.9rem;
  }

  /* .schedule-text span {
    display: none;

  } */

  .white-box {
    /* margin: 0 10px; */
    height: 70px;
    width: 70px;
  }

  /* .video-youtube {
    width: 100%;
    height: 160px;
  } */

  .hero-section {
    background-position: -330px 0px;
  }

  .row-carousel-item {
    /* padding: 0; */
  }
}
</style>
